export const calculateDuration = (selectedDuration) => {
    const today = new Date();
    let newStartDate = '';
    let newEndDate = today.toISOString().split('T')[0];

    switch (selectedDuration) {
        case 'currentweek':
            const firstDayOfWeek = new Date(
                today.setDate(today.getDate() - today.getDay())
            );
            newStartDate = firstDayOfWeek.toISOString().split('T')[0];
            break;
        case 'last12months':
            const lastYear = new Date();
            lastYear.setFullYear(today.getFullYear() - 1);
            newStartDate = lastYear.toISOString().split('T')[0];
            break;
        case 'last6years':
            const last6Years = new Date();
            last6Years.setFullYear(today.getFullYear() - 6);
            newStartDate = last6Years.toISOString().split('T')[0];
            break;
        case 'all':
            newStartDate = '';
            break;
        default:
            newStartDate = '';
    }
    return {newStartDate, newEndDate}
};